import React from "react";
import {View, Text, StyleSheet, Image, TouchableOpacity, ImageBackground, ScrollView} from 'react-native';
import {RFValue} from "react-native-responsive-fontsize";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";
import {Foundation} from "@expo/vector-icons";
import Octicons from "@expo/vector-icons/Octicons";


const Examresult = ({navigation,route})=>{

    let exam = JSON.parse(route.params.exam);
    console.log(route.params.exam);
    return (
        <ScrollView style={styles.container}>
            <View style={styles.header}>
                {exam.percent > 65 &&
                <>
                    <ImageBackground  resizeMode="cover" source={require('../../assets/images/win.png')}

                                      style={styles.image}
                    />
                    <View style={styles.boxgreen}>
                        <Text style={styles.greentext}>{exam.percent}%</Text>
                    </View>
                </>
                }
                {exam.percent > 40 && exam.percent < 65 && (

                        <View style={styles.boxyellow}>
                            <Text style={styles.yellowtext}>{exam.percent}%</Text>
                        </View>

                )}

                {exam.percent < 40 &&
                    <View style={styles.boxred}>
                        <Text style={styles.rdtext}>{exam.percent}%</Text>
                    </View>
                }


            </View>
            <View style={{justifyContent:'center', alignItems:'center'}}>


                {exam.percent > 65 &&
                    <>
                        <Text style={styles.title}>
                            خیلی فوق‌العاده بود!
                        </Text>
                        <Text style={styles.subtitle}>
                            همین‌جوری ادامه بده و همه رکوردها رو بشکن
                        </Text>
                    </>
                }
                {exam.percent > 40 && exam.percent < 65 && (
                    <>
                        <Text style={styles.title}>
                            یکم دیگه تلاش کن!
                        </Text>
                        <Text style={styles.subtitle}>
                            مطمئنم با تلاش بیشتر، به نتیجه عالی می‌رسی
                        </Text>
                    </>
                )}
                {exam.percent < 40 &&
                    <>
                        <Text style={styles.title}>
                            تو شکست نخوردی، داری یاد می‌گیری!
                        </Text>
                        <Text style={styles.subtitle}>
                            بلند شو، ادامه بده و دفعه بعد نتیجه بهتری بگیر
                        </Text>
                    </>
                }


                <Text style={styles.time}>
                    <AntDesign name="clockcircleo" style={{margiLeft : 20}} size={24} color="#FFCC3E" />
                    {`  `}
                    {exam.time}
                </Text>
                <View style={{justifyContent:'space', alignItems:'center' ,flexDirection:'row', width : '100%'}}>
                    <View style={styles.boxresultgreen}>
                        <Text style={styles.gt}>{exam.truee}</Text>
                        <Text style={styles.gt}>صحیح</Text>
                    </View>
                    <View style={styles.boxresultred}>
                        <Text style={styles.rt}>{exam.falsee}</Text>
                        <Text style={styles.rt}>خطا</Text>
                    </View>

                </View>
            </View>


            <TouchableOpacity
                style={{
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',

                    marginHorizontal : 'auto',
                    marginTop: RFValue(10),
                    borderRadius: RFValue(10),
                    borderWidth : 1,
                    padding : RFValue(10),
                    // borderColor: Config.maincolor,
                    borderColor : '#E7E9F2',
                    backgroundColor : Config.secondcolor
                }}

                onPress={()=>{
                navigation.navigate('Home');
            }}>
                <Octicons name="home" size={RFValue(20)} color={Config.maincolor} style={{marginHorizontal:'5'}} />

                <Text style={styles.buttonTextresult}>
                    {`  `}
                    بازگشت به خانه
                </Text>

            </TouchableOpacity>
            <TouchableOpacity style={styles.buttonresult} onPress={()=>{
                navigation.navigate('Exam',{
                    lesson_id: exam.lesson_id,
                    category_id: exam.category_id,
                });
            }}>
                <Text style={styles.buttonTextresult}>
                    {/*مشاهده پاسخ‌های آزمون*/}
                    تکرار و تمرین

                </Text>
                <AntDesign name="left" size={24} color="black" />
            </TouchableOpacity>

            <View style={{flex: 1, justifyContent: 'center'}}>
                <TouchableOpacity onPress={()=>{
                    navigation.navigate('Course',{
                        course_id: exam.course_id,
                    });
                }} style={styles.button}>
                    <Text style={styles.buttonText}> ادامه </Text>
                </TouchableOpacity>


                {/*<TouchableOpacity onPress={()=>{*/}
                {/*    navigation.navigate('Exam',{*/}
                {/*        lesson_id: exam.lesson_id,*/}
                {/*    });*/}



                {/*}} style={styles.moroor}>*/}
                {/*    <Foundation name="refresh" size={RFValue(15)} color={Config.maincolor} />*/}
                {/*    <Text style={styles.buttonText2}>*/}
                {/*        {` `}*/}
                {/*        آزمون مجدد*/}
                {/*    </Text>*/}
                {/*</TouchableOpacity>*/}

            </View>

        </ScrollView>
    );
}

const styles = StyleSheet.create({
    moroor : {
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        marginTop : RFValue(10),
        marginBottom : RFValue(20),

    },
    buttonText2 : {
        fontFamily : 'yk',
        fontSize : RFValue(16),
        color : Config.maincolor,
    },
    buttonText : {
        fontFamily : 'ykb',
        fontSize : RFValue(16),
        color : Config.maincolor,
    },
    button : {
        backgroundColor: Config.secondcolor,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop : RFValue(20),
        borderRadius : RFValue(30),
        height : RFValue(40),

    },

    buttonresult : {
        borderColor : '#E7E9F2',
        flexDirection : 'row',
        justifyContent : 'space-between',
        alignItems: 'center',
        borderWidth: 1,
        backgroundColor : 'white',
        marginTop : RFValue(20),
        padding : RFValue(15),
        borderRadius : RFValue(15),
    },

    buttonTextresult : {
        color: Config.maincolor,
        textAlign: "center",
        fontFamily : 'ykb',
        fontSize : RFValue(14),
        // marginTop: RFValue(20),
    },

    boxresultgreen : {
        backgroundColor: '#E9FFE0',
        borderWidth : 1,
        borderRadius : RFValue(20),
        height : RFValue(100),
        width : '45%',
        justifyContent: 'center',
        alignItems: 'center',
        borderColor : '#33B300',
        margin : RFValue(10),
    },
    boxresultred : {
        backgroundColor: '#FFD5D5',
        borderWidth : 1,
        borderRadius : RFValue(20),
        borderColor : '#D90000',
        height : RFValue(100),
        width : '45%',
        justifyContent: 'center',
        alignItems: 'center',
        margin : RFValue(10),
    },
    gt : {
        color: "#33B300",
        textAlign: "center",
        fontFamily : 'ykb',
        fontSize : RFValue(17),
        marginTop: RFValue(5),
    },
    rt : {
        color: "#D90000",
        textAlign: "center",
        fontFamily : 'ykb',
        fontSize : RFValue(17),
        marginTop: RFValue(5),
    },

    time : {
        color: "#FFCC3E",
        textAlign: "center",
        fontFamily : 'ykb',
        fontSize : RFValue(20),
        marginTop: RFValue(20),
    },
    title : {
        color: "#0D1134",
        textAlign: "center",
        fontFamily : 'ykb',
        fontSize : RFValue(20),
        marginTop: RFValue(20),
    },
    subtitle : {
        color: "#0D1134",
        textAlign: "center",
        fontFamily : 'yk',
        fontSize : RFValue(14),
        marginTop: RFValue(7),

    },
    image: {
        flex: 1,
        justifyContent: 'center',
        width : RFValue(220),
        height : RFValue(220),
        marginTop : -RFValue(40),
        position: 'absolute',
    },
    container: {
        flex: 1,
        backgroundColor: '#FAFAFA',
        paddingVertical: RFValue(5),
        paddingHorizontal: RFValue(20),
    },
    boxgreen: {
        width : RFValue(150),
        height : RFValue(150),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius : '50%',
        borderWidth : RFValue(6),
        borderColor : '#33B300'
    },
    greentext : {
      fontSize : RFValue(20),
        fontFamily : 'ykb',
        color : '#33B300',
    },

    boxyellow: {
        width : RFValue(150),
        height : RFValue(150),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius : '50%',
        borderWidth : RFValue(6),
        borderColor : '#F28B1C'
    },
    yellowtext : {
        fontSize : RFValue(20),
        fontFamily : 'ykb',
        color : '#F28B1C',
    },
    boxred: {
        width : RFValue(150),
        height : RFValue(150),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius : '50%',
        borderWidth : RFValue(6),
        borderColor : '#D90000'
    },
    redtext : {
        fontSize : RFValue(20),
        fontFamily : 'ykb',
        color : '#90000',
    },



    header : {
        justifyContent: 'center',
        alignItems: 'center',
        width : '100%',
        // height : RFValue(95),
        marginTop: RFValue(40),
    }

})

export default Examresult;